import React from 'react';
import { Form, Select } from 'antd';
import { ComponentTypes } from '../../../common/componentUtils';
import { t } from '../../../utils';

const fontSizes = [
	'8',
	'9',
	'10',
	'11',
	'12',
	'14',
	'16',
	'18',
	'20',
	'24',
	'28',
	'32',
	'36',
	'40',
	'48',
	'56',
	'64',
	'72',
	'80',
];

const fontSizeOptions = fontSizes.map(val => ({
	label: val + 'px',
	value: val,
}));

export const AnnotationsEditor = ({ componentsToEdit, handleComponentUpdate }) => {
	const [form] = Form.useForm();
	const component = componentsToEdit[0];

	const handleUpdate = (updatedAttribute: string, updatedValue: any) => {
		handleComponentUpdate(
			[
				{
					...component,
					[updatedAttribute]: updatedValue,
				},
			],
			'update'
		);
	};

	return (
		<Form form={form} layout="vertical" style={{ maxWidth: 280 }}>
			{component.type === ComponentTypes.TextAnnotationComponent && (
				<Form.Item label={t('components.editor.fontSizeLabel')}>
					<Select
						value={`${component?.fontSize}px`}
						onChange={e => handleUpdate('fontSize', parseInt(e, 10))}
						options={fontSizeOptions}
					/>
				</Form.Item>
			)}
		</Form>
	);
};
